/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { Form } from '@organisms';
import { COL_WITH_EXTRA } from '@constants';
import ROUTES from '@constants/routes';

import LocationSelect from '../LocationSelect';

const LocationField = React.forwardRef(
  (
    {
      initialLocation,
      wrapperCol,
      disabled,
      onChange,
      onSearch,
      showAction,
      placeholder,
      queryVariables,
      value,
      ...props
    },
    ref,
  ) => {
    const [selectedLocation, setSelectedLocation] = React.useState(initialLocation);

    const handleChange = (location) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(location);
      setSelectedLocation(location);
    };

    return (
      <>
        <Form.WithFieldValue name={props.name}>
          {(_value) => {
            if (!_value) {
              setSelectedLocation(undefined);
            }
          }}
        </Form.WithFieldValue>
        <Form.ItemWithExtra
          wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
          extra={
            !!selectedLocation && (
              <Link to={`/${ROUTES.LOCATIONS}/${selectedLocation.id}`} target="_blank" rel="noopener noreferrer">
                Location setup
              </Link>
            )
          }
          {...props}
        >
          <LocationSelect
            value={value}
            ref={ref}
            onChange={handleChange}
            disabled={disabled}
            onSearch={onSearch}
            showAction={showAction}
            placeholder={placeholder}
            queryVariables={queryVariables}
          />
        </Form.ItemWithExtra>
      </>
    );
  },
);

export default LocationField;
